export default "__VITE_ASSET__BK8gAU8m__"